import axiosInstance from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Toast } from "shared";
import { toast } from "react-toastify";
import { SESSION_QUERY_KEY } from './CheckSessionHook'
import { queryClient } from 'App'

export type GetResetPasswordCodePayload = {
  password: string;
};

export const useGetResetPasswordCode = (
  options?: UseMutationOptions<any, Error, GetResetPasswordCodePayload>
) => {
  return useMutation({
    mutationKey: ["successors", "resetPasswordCode"],
    mutationFn: async (payload: GetResetPasswordCodePayload) => {
      return axiosInstance
        .post(`/successors/reset-password-code`, payload)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Pobieram kod…",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "get-reset-password-code",
      });
      if (options?.onMutate) return options.onMutate(variables);
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message:"Sprawdz kod w wiadomości e-mail",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "get-reset-password-code",
      });
      if (options?.onSuccess) options.onSuccess(data, variables, context);
    },
    onError: (error: any, variables, context) => {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      const status = error?.status ?? error?.response?.status;
      if (status === 422) {
        Toast({
          message: "Nieprawidłowe dane",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "get-reset-password-code",
        });
      } else if (status === 500) {
        Toast({
          message: "Błąd serwera",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "get-reset-password-code",
        });
      } else {
        toast.dismiss("get-reset-password-code");
      }

      if (options?.onError) options.onError(error, variables, context);
    },
  });
};
